var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1A4199"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.676 7.125l10.732 6.191v6.319L5 10.159l5.265-3.034a.42.42 0 01.42 0",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M21.408 7l-5.467 3.16 5.467 3.156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.408 7l5.264 3.036a.42.42 0 01.22.367v12.389l-5.484-3.157V7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.881 22.792l-5.264 3.033a.44.44 0 01-.42 0l-10.732-6.19v-6.328l16.416 9.485z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.16v12.387a.42.42 0 00.22.368l5.265 3.036V13.307L5 10.16z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.476 25.95l5.465-3.158-5.465-3.157z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexo);
export default __webpack_public_path__ + "static/media/nexo.0b1c4fbb247a3168fafd2a55cc27657f.svg";
export { ForwardRef as ReactComponent };